/*global oxygenCss*/
import React, { Component, PropTypes } from 'react';
import Drawer from 'components/Drawer';
import ScrollableContainer from 'components/Tasks/ScrollableContainer';
import * as SvgIcons from 'components/Material/SvgIcons';
import { StoreOverviewActions } from 'actions';
import { Units, hexToRgba, Colors } from 'Css';
import {
  Toolbar,
  ToolbarGroup,
  ToolbarButton,
  ToolbarTitle
} from 'components/Toolbar';

const css = oxygenCss({
  root: {
    overflow: 'hidden'
  },
  row: {
    position: 'relative',
    display: 'flex'
  },
  column: {
    position: 'relative',
    textAlign: 'center',
    boxSizing: 'border-box',
    margin: Units.base / 2,
    flex: 1,
    backgroundColor: '#F0F0F0',
    height: Units.keyline * 2.5,
    cursor: 'pointer',
    padding: `${Units.keyline / 2}px 0`,
    ':hover': {
      backgroundColor: `${hexToRgba(Colors.creen, 10)}`
    }
  },
  header: {
    lineHeight: `24px`,
    fontSize: 16,
    fontWeight: 400,
    textAlign: 'center',
    letterSpacing: '0.3px'
  },
  container: {
    padding: `${Units.keyline}px 0`
  }
});

const styles = {
  icon: {
    width: Units.base * 6,
    height: Units.base * 6
  }
};

const Icons = {
  Text: SvgIcons.EditorFormatAlignLeft,
  Banner: SvgIcons.ImageLandscape,
  Image: SvgIcons.ImageImage,
  Video: SvgIcons.AvMovie,
  List: SvgIcons.ImageViewComfy,
  Filter: SvgIcons.ContentFilterList
};

class StoreModuleMenu extends Component {
  static propTypes = {};

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  closeModuleMenu = () => {
    StoreOverviewActions.closeModuleMenu();
  };

  addList = () => {
    StoreOverviewActions.addModule(
      {
        type: 'banner'
      },
      {
        type: 'List'
      }
    );
  };

  addImage = () => {
    StoreOverviewActions.addModule(
      {
        type: 'default'
      },
      {
        type: 'Image',
        src: '/images/library.jpg',
        caption: null
      }
    );
  };

  addVideo = () => {
    StoreOverviewActions.addModule(
      {
        type: 'default'
      },
      {
        type: 'Video',
        src: null,
        caption: null
      }
    );
  };

  addBanner = () => {
    const { getIntlMessage } = this.context;
    StoreOverviewActions.addModule(
      {
        type: 'banner'
      },
      {
        type: 'Banner',
        src: '/images/library.jpg',
        color: '#FFFFFF',
        backgroundColor: '#000000',
        size: 1,
        header: getIntlMessage('storeBuilder.thisIsMyStore')
      }
    );
  };

  addText = () => {
    const { getIntlMessage } = this.context;
    StoreOverviewActions.addModule(
      {
        type: 'default'
      },
      {
        type: 'Text',
        __html: getIntlMessage('storeBuilder.thisIsMyStore')
      }
    );
  };

  addFilter = () => {
    StoreOverviewActions.addModule(
      {
        type: 'default'
      },
      {
        type: 'Filter'
      }
    );
  };

  render() {
    const { ...other } = this.props;

    const { getIntlMessage } = this.context;

    return (
      <Drawer
        slide={false}
        className={css.root}
        onRequestClose={this.closeModuleMenu}
        {...other}
      >
        <ScrollableContainer
          padded
          header={
            <Toolbar>
              <ToolbarGroup>
                <ToolbarButton
                  onTouchTap={this.closeModuleMenu}
                  tooltip={getIntlMessage('Close')}
                >
                  <SvgIcons.ContentClear />
                </ToolbarButton>
              </ToolbarGroup>
              <ToolbarTitle>{getIntlMessage('store.addContent')}</ToolbarTitle>
            </Toolbar>
          }
        >
          <div className={css.container}>
            <div className={css.row}>
              <div className={css.column} onTouchTap={this.addList}>
                <Icons.List color={'#777777'} style={styles.icon} />
                <div className={css.header}>
                  {getIntlMessage('store.coursesModule')}
                </div>
              </div>
              <div className={css.column} onTouchTap={this.addFilter}>
                <Icons.Filter color={'#777777'} style={styles.icon} />
                <div className={css.header}>
                  {getIntlMessage('store.filter')}
                </div>
              </div>
            </div>
            <div className={css.row}>
              <div className={css.column} onTouchTap={this.addBanner}>
                <Icons.Banner color={'#777777'} style={styles.icon} />
                <div className={css.header}>
                  {getIntlMessage('store.bannerModule')}
                </div>
              </div>
              <div className={css.column} onTouchTap={this.addVideo}>
                <Icons.Video color={'#777777'} style={styles.icon} />
                <div className={css.header}>
                  {getIntlMessage('store.videoModule')}
                </div>
              </div>
            </div>
            <div className={css.row}>
              <div className={css.column} onTouchTap={this.addImage}>
                <Icons.Image color={'#777777'} style={styles.icon} />
                <div className={css.header}>
                  {getIntlMessage('store.imageModule')}
                </div>
              </div>
              <div className={css.column} onTouchTap={this.addText}>
                <Icons.Text color={'#777777'} style={styles.icon} />
                <div className={css.header}>
                  {getIntlMessage('store.textModule')}
                </div>
              </div>
            </div>
          </div>
        </ScrollableContainer>
      </Drawer>
    );
  }
}

export default StoreModuleMenu;



// WEBPACK FOOTER //
// ./src/js/components/Store/Editor/StoreModuleMenu.js